import { useContext, useEffect } from "react";
import styles from './BannerPage.module.css'

import "./BannerPart3.css";
import { dataContext } from "../../App";
import activityLogSubmission from "../../helper/activitylog";
import analyticEvent from "../../helper/gaEvent";
import CategoryBox from "./categoryBox/categoryBox";
import QuizChallenges from "./QuizChallenges/QuizChallenges";
import PromotionalBanner from "./PromotionalBanner/PromotionalBanner";
import PlayerStatusCard from "./PlayerStatusCard/PlayerStatusCard";
import PlayingHistory from "./PlayingHistory/PlayingHistory";
const BannerPart3 = ({ props }) => {
  const { playerData, events } =
    useContext(dataContext);
  const { quizClickHandler, setShowShobDekho, setActiveBottom } = props;

  useEffect(() => {
    let msisdn = null;

    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("home", msisdn);
    analyticEvent('home', 'home-view')
  }, []);

  return (
    <>
      <div className={styles.bannerPageBody}>
        <PlayerStatusCard data={playerData} />
        <QuizChallenges quizClickHandler={quizClickHandler} setShowShobDekho={setShowShobDekho} donotShowSwiper={true} />
        {/* <OtherQuizesChallanges quizClickHandler={quizClickHandler} setShowShobDekho={setShowShobDekho} /> */}
        <CategoryBox props={{ events, quizClickHandler }} />
        {/* <PromotionalBanner
          bannerSrc={"/banners/promotional/cashback.webp"}
          handleClick={() => { setActiveBottom('subscription'); activityLogSubmission('10tk_cash_back'); }} /> */}
        {/* <PlayingHistory events={events} playerData={playerData} quizClickHandler={quizClickHandler} /> */}
        {/* <PromotionalBanner bannerSrc={"/banners/promotional/referral_v2.webp"} handleClick={() => { setActiveBottom('referral'); activityLogSubmission('10tk_cash_in'); }} /> */}
      </div>
    </>
  );
};

export default BannerPart3;
